export default {
    header: {
        textTransform: 'uppercase',
        fontWeight: '500',
        fontSize: '2em',
        lineHeight: '4'
    }, 
    content: {
        width: "49%",
        marginBottom: "5%",
    },
    Text: {
        color: 'black',
    },
    column: {
        alignItems: 'center',
    }
}



// WEBPACK FOOTER //
// ./src/views/Research/styles.js